import { render } from "./ContinueBtn.vue?vue&type=template&id=8f810d1e"
import script from "./ContinueBtn.vue?vue&type=script&lang=js"
export * from "./ContinueBtn.vue?vue&type=script&lang=js"

import "./ContinueBtn.vue?vue&type=style&index=0&id=8f810d1e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__